import { Link } from "react-router-dom";
import { usePrivilege } from "../../../../../components/priviledge/PriviledgeProvider";
import { menuRoutes } from "../../../../../router/menu";
import { Contract } from "../../../../../type/entities/contract-type";
import cn from "../../../../../utils/classNames";
import { formatInfoDate, formatInfoValue, InfoCard, InfoField, InfoGroup } from "./components/InfoDisplay";

interface ClientContractFormInfoProps {
    data: Contract;
}

const ClientContractFormInfo = ({ data }: ClientContractFormInfoProps) => {
    const { userCan } = usePrivilege();
    const canViewClient = userCan("get_students", "students");

    return (
        <InfoCard
            title="Datos del Cliente"
            subtitle="Cliente asociado al contrato."
            action={canViewClient ? (
                <Link
                    className={cn("text-primary hover:text-blue-700 font-semibold")}
                    to={`/clients/${data?.client?.id}/profile${menuRoutes.clients.profile.info}`}
                    state={{
                        fromContract: true,
                        organisingCorporationId: data?.organisingCorporation?.id || null,
                        returnToContractPath: `${menuRoutes.contracts.path}/${data?.id}/profile${menuRoutes.contracts.profile.info}`,
                    }}
                >
                    Ver Cliente
                </Link>
            ) : undefined}
        >
            <InfoGroup title="Información General" description="Datos principales del cliente en este contrato.">
                <InfoField label="CIF/NIF" value={formatInfoValue(data?.clientCifNif)} className="md:col-span-3" />
                <InfoField label="Teléfono" value={formatInfoValue(data?.clientTelephone)} className="md:col-span-4" />
                <InfoField label="Razón Social" value={formatInfoValue(data?.clientCompanyName)} className="md:col-span-5" />
                <InfoField label="IBAN" value={formatInfoValue(data?.clientIban)} className="md:col-span-4" />
                <InfoField label="Nº Seguridad Social" value={formatInfoValue(data?.clientSocialSecurityNumber)} className="md:col-span-3" />
                <InfoField label="Email" value={formatInfoValue(data?.clientEmail)} className="md:col-span-5" />
                <InfoField label="CNAE" value={formatInfoValue(data?.clientCnae)} className="md:col-span-2" />
                <InfoField label="Descripción de la Actividad" value={formatInfoValue(data?.clientActivity)} className="md:col-span-10" />
                <InfoField label="Móvil" value={formatInfoValue(data?.clientMobile)} className="md:col-span-4" />
                <InfoField label="Teléfono adicional 1" value={formatInfoValue(data?.clientTelephoneSecondary)} className="md:col-span-4" />
                <InfoField label="Teléfono adicional 2" value={formatInfoValue(data?.clientTelephoneThird)} className="md:col-span-4" />
                <InfoField label="Creación de la Empresa" value={formatInfoDate(data?.clientCompanyCreationDate)} className="md:col-span-3" />
                <InfoField label="Nº trabajadores" value={formatInfoValue(data?.clientWorkersNumber)} className="md:col-span-2" />
                <InfoField label="Empresa con RLT" value={data?.clientHasRlt === true ? 'Sí' : data?.clientHasRlt === false ? 'No' : '-'} className="md:col-span-2" />
                <InfoField label="Código BIC" value={formatInfoValue(data?.clientBic)} className="md:col-span-3" />
            </InfoGroup>

            <InfoGroup title="Domicilio Social" description="Dirección del cliente asociada al contrato.">
                <InfoField label="Dirección" value={formatInfoValue(data?.clientAddress)} className="md:col-span-4" />
                <InfoField label="Población" value={formatInfoValue(data?.clientCity)} className="md:col-span-2" />
                <InfoField label="Provincia" value={formatInfoValue(data?.clientProvince)} className="md:col-span-3" />
                <InfoField label="C.P." value={formatInfoValue(data?.clientPostalCode)} className="md:col-span-3" />
            </InfoGroup>
        </InfoCard>
    );
};

export default ClientContractFormInfo;
